import React, { Component } from "react";
import moment from "moment";
import { GoStop } from "react-icons/go";

export function mdyDateFormat(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join("-");
}

export const calaculateYearsDifferenceForPastDate = (date, type) => {
  let dobDate = moment(date, "YYYY-MM-DD");
  return moment().diff(dobDate, type);
};

export function chatDateFormat(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    hour = d.getHours(),
    minute = d.getMinutes();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  let time = [hour, minute].join(":");

  return [day, month, year].join("-") + " " + time;
}
export function mdyhmsDateFormat(date) {
  var d = new Date(date),
    dformat =
      [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("-") +
      " " +
      [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");

  return dformat;
}

export function hmsToSeconds(s) {
  var b = s.split(":");
  return b[0] * 3600 + b[1] * 60 + (+b[2] || 0);
}

export function secondsToHMS(secs) {
  function z(n) {
    return (n < 10 ? "0" : "") + n;
  }
  var sign = secs < 0 ? "-" : "";
  secs = Math.abs(secs);
  return (
    sign + z((secs / 3600) | 0) + ":" + z(((secs % 3600) / 60) | 0) + ":" + z(secs % 60)
  );
}

export function hmsToDecimalHour(s) {
  var b = s.split(":");
  let result = parseInt(b[0]) + parseInt(b[1]) / 60 + parseInt(b[2]) / 3600;

  return result.toFixed(2);
}

var monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function diff(from, to) {
  var arr = [];
  var datFrom = new Date(from);
  var datTo = new Date(to);
  var fromYear = datFrom.getFullYear();
  var toYear = datTo.getFullYear();
  var diffYear = 12 * (toYear - fromYear) + datTo.getMonth();

  for (var i = datFrom.getMonth(); i <= diffYear; i++) {
    arr.push(monthNames[i % 12] + " " + Math.floor(fromYear + i / 12));
  }

  return arr;
}

export function moduleName(moduleList, moduleKey) {
  let module = moduleList.filter((module) => module.id === moduleKey);

  let name = "";
  if (module && module.length > 0) {
    name = module[0].label;
  }
  return name;
}

export function subModuleName(subModuleList, subModuleKey) {
  let name = "";

  for (const key in subModuleList) {
    if (subModuleList.hasOwnProperty(key)) {
      let subModule = subModuleList[key];
      subModule.forEach((element) => {
        if (element.id === subModuleKey) {
          name = element.label;
        }
      });
    }
  }
  return name;
}

export function closestDate(data) {
  var arr = [];
  let result = {};
  // data.forEach(d => {
  for (let index = 0; index < data.length; index++) {
    const d = data[index];

    if (d.dueDate && d.isCompleted != 1) {
      result = d;
      break;
      arr.push(new Date(d.dueDate));
    }
  }

  return result;

  var diffdate = new Date();

  arr.sort(function (a, b) {
    var distancea = Math.abs(diffdate - a);
    var distanceb = Math.abs(diffdate - b);
    return distancea - distanceb; // sort a before b when the distance is smaller
  });

  let afterdates = arr.filter(function (d) {
    return d - diffdate > 0;
  });

  let rr = null;

  if (afterdates && afterdates.length > 0) {
    let closeDate = afterdates[0];
    rr = data.filter((d) => {
      if (d.dueDate && d.isCompleted != 1) {
        let dueDate = new Date(d.dueDate);

        var same = dueDate.getTime() === closeDate.getTime();
        if (same) {
          return d;
        }
      }
    });
  }

  return rr && rr.length > 0 ? rr[0] : rr;
}

export function fileExtention(name) {
  let extenstion = name ? name.split(".").pop().toLowerCase() : name;
  // extenstion = extenstion ? extenstion.toLowerCase() : extenstion;
  return extenstion;
}

export function formatDDMMYYYYbyYYYYMMDD(date) {
  if (!date || date === "0000-00-00") return "";

  if (moment(date, "YYYY-MM-DD hh:mm a", true).isValid())
    return moment(date, "YYYY-MM-DD hh:mm a").format("DD-MM-YYYY hh:mm a");
  if (moment(date, "YYYY-MM-DD", true).isValid())
    return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
  if (moment(date, "YYYY-MM-DD HH:mm:ss", false).isValid())
    return moment(date).format("DD-MM-YYYY HH:mm:ss");
  if (moment(date, "YYYY-MM-DD HH:mm:ss", true).isValid())
    return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm:ss");

  if (moment(date).isValid()) return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");

  return date;
}

export function decimalPointNumber(x, n) {
  return parseFloat(Number.parseFloat(x).toFixed(n));
}

export function timeDiffInHours(timeFrom, timeTo) {
  let hours = null;
  if (timeFrom && timeTo) {
    timeFrom = moment(timeFrom, "HH:mm").format("HH:mm");
    timeTo = moment(timeTo, "HH:mm").format("HH:mm");

    if (timeFrom && timeTo) {
      if (timeFrom < timeTo) {
        hours = secondsToHMS(hmsToSeconds(timeTo) - hmsToSeconds(timeFrom));

        hours = hmsToDecimalHour(hours);
      } else if (timeFrom > timeTo) {
        let timeFrom_date = "January 1, 2020 " + timeFrom;
        let timeTo_date = "January 2, 2020 " + timeTo;

        timeFrom_date = new Date(timeFrom_date);
        timeTo_date = new Date(timeTo_date);

        var seconds = (timeTo_date.getTime() - timeFrom_date.getTime()) / 1000;

        hours = secondsToHMS(seconds);
        hours = hmsToDecimalHour(hours);
      }
    }
  }
  return hours;
}

export const isDateBetween = (date, fromDate, toDate) => {
  for (const value of [date, fromDate, toDate])
    if (!value?.match(/^\d{4}-\d{2}-\d{2}$/)) return false;

  const dateValue = new Date(date).getTime();

  return (
    dateValue >= new Date(fromDate).getTime() && dateValue < new Date(toDate).getTime()
  );
};

export const addedMonthsDate = (date, monthsCount) => {
  if (!date || !monthsCount || monthsCount < 0) return "";

  const isMonthFull = (month) => (month < 8 ? month % 2 === 1 : month % 2 === 0);

  const selectedDay = new Date(date).getDate();
  const selectedMonth = new Date(date).getMonth() + 1 + +monthsCount;

  const year = new Date(date).getFullYear() + parseInt((selectedMonth - 1) / 12);
  const month = selectedMonth <= 12 ? selectedMonth : selectedMonth % 12 || 12;
  const day =
    selectedDay < 29
      ? selectedDay
      : month !== 2
      ? selectedDay !== 31
        ? selectedDay
        : isMonthFull(month)
        ? 31
        : 30
      : year % 4 === 0
      ? 29
      : 28;

  return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;

  // ================= OLD METHOD ================
  // const finaleDate = new Date(new Date(date).getTime() + +monthsCount * 30 * 24 * 60 * 60 * 1000); // Month x Days x Hours x Minutes x Seconds x 1000 (Mili-Seconds)
  // const month = finaleDate.getMonth() + 1;
  // const day = finaleDate.getDate();
  // return `${finaleDate.getFullYear()}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
};

export const startOfMoment = (
  date,
  informat = "MM-YYYY",
  startOf = "month",
  outFormat = "YYYY-MM-DD"
) => {
  return moment(date, informat).startOf(startOf).format(outFormat);
};

export const endOfMoment = (
  date,
  informat = "MM-YYYY",
  endOf = "month",
  outFormat = "YYYY-MM-DD"
) => {
  return moment(date, informat).endOf(endOf).format(outFormat);
};

export const convertinMinsToHours_mins = (time) => {
  let hours = Math.floor(time / 60);
  let mins = time % 60;

  if (hours < 10) hours = "0" + hours;
  if (mins < 10) mins = "0" + mins;

  return hours + " : " + mins;
};

export const normalizeDateTime = (dateTime) =>
  dateTime ? moment(dateTime).format("YYYY-MM-DD HH:mm:ss") : "";

export const getKeyByValue = (object, value) => {
  console.log("object", object);
  console.log("value", value);

  console.log(
    "nameee",
    Object.keys(object).find((key) => object[key] === value)
  );

  return Object.keys(object).find((key) => object[key] === value);
};

export const getQuarterObj = (date) => {
  let quarter = Math.ceil((date.getMonth() + 1) / 3);
  let from = null;
  let to = null;
  let name = null;

  switch (quarter) {
    case 1:
      from = [date.getFullYear(), "01", "01"].join("-");
      to = [date.getFullYear(), "03", "31"].join("-");

      name = `Jan - Mar ${date.getFullYear()}`;

      break;
    case 2:
      from = [date.getFullYear(), "04", "01"].join("-");
      to = [date.getFullYear(), "06", "30"].join("-");

      name = `Apr - Jun ${date.getFullYear()}`;

      break;
    case 3:
      from = [date.getFullYear(), "07", "01"].join("-");
      to = [date.getFullYear(), "09", "30"].join("-");

      name = `Jul - Sep ${date.getFullYear()}`;

      break;
    case 4:
      from = [date.getFullYear(), "10", "01"].join("-");
      to = [date.getFullYear(), "12", "31"].join("-");

      name = `Oct - Dec ${date.getFullYear()}`;

      break;

    default:
      break;
  }
  return {
    year: date.getFullYear(),
    quarter: quarter,
    from,
    to,
    name,
  };
};

export const previous4Quarter = () => {
  // Copy input start date do don't affect original
  let sDate = new Date();

  // Set to 2nd of month so adding months doesn't roll over
  // and not affected by daylight saving
  sDate.setDate(2);

  // Initialise result array with start quarter

  var result = [getQuarterObj(sDate)];

  // List quarters from start to end
  while (true) {
    sDate.setMonth(sDate.getMonth() - 3);
    result.push(getQuarterObj(sDate));

    if (result.length == 4) break;
  }

  return result;
};

export const previousCurrentQuarter = () => {
  // Copy input start date do don't affect original
  let sDate = new Date();

  // Set to 2nd of month so adding months doesn't roll over
  // and not affected by daylight saving
  sDate.setDate(2);

  // Initialise result array with start quarter

  var result = [this.getQuarterObj(sDate)];

  // List quarters from start to end
  while (true) {
    sDate.setMonth(sDate.getMonth() - 3);
    result.push(this.getQuarterObj(sDate));

    if (result.length == 2) break;
  }
};
export const previous8Quarter = () => {
  // Copy input start date do don't affect original
  let sDate = new Date();

  // Set to 2nd of month so adding months doesn't roll over
  // and not affected by daylight saving
  sDate.setDate(2);

  // Initialise result array with start quarter

  var result = [getQuarterObj(sDate)];

  // List quarters from start to end
  while (true) {
    sDate.setMonth(sDate.getMonth() - 3);
    result.push(getQuarterObj(sDate));

    if (result.length == 8) break;
  }

  return result;
};

export const listQuartersSince2020 = () => {
  // Copy input start date do don't affect original
  let sDate = new Date(2020, 0, "01");

  // Set to 2nd of month so adding months doesn't roll over
  // and not affected by daylight saving
  // sDate.setDate(2);

  // Initialise result array with start quarter

  var result = [getQuarterObj(sDate)];

  let cuurentQuater = getQuarterObj(new Date());

  // List quarters from start to end
  while (getQuarterObj(sDate).name != cuurentQuater.name) {
    sDate.setMonth(sDate.getMonth() + 3);
    result.push(getQuarterObj(sDate));
  }

  return result;
};

export const checkExpire = (date, type, value) => {
  if (date && value !== "" && value !== null) {
    var result = new Date(date);
    switch (type) {
      case "Days":
        return moment
          .unix(result.setDate(result.getDate() + +value) / 1000)
          .format("YYYY-MM-DD");
      case "Months":
        return moment
          .unix(result.setMonth(result.getMonth() + +value) / 1000)
          .format("YYYY-MM-DD");
      case "Year":
        return moment
          .unix(result.setFullYear(result.getFullYear() + +value) / 1000)
          .format("YYYY-MM-DD");
      default:
        return "";
    }
  }
  return "";
};

export const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const isString = (str) => {
  try {
    if (typeof str === "string") return true;
    else return false;
  } catch (e) {
    return false;
  }
};

export const isNumber = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const isObj = (obj) => {
  if (obj && typeof obj === "object") return true;
  return false;
};

export function encodeQueryObject(obj) {
  let query = "";

  for (const key in obj) {
    if (typeof obj[key] !== "object") {
      const newQ = `${key}=${obj[key]}`;
      query += query ? `&${newQ}` : newQ;
    } else
      for (const k in obj[key]) {
        const newQ = `${key}[${k}]=${obj[key][k]}`;
        query += query ? `&${newQ}` : newQ;
      }
  }

  return query;
}

export function getQueryStringAsObject() {
  const search = window.location.search.slice(1);

  try {
    const obj = !search
      ? {}
      : JSON.parse(
          '{"' +
            decodeURIComponent(search)
              .replace(/"/g, '\\"')
              .replace(/&/g, '","')
              .replace(/=/g, '":"') +
            '"}'
        );

    for (const key in obj)
      if (obj[key] === "null") obj[key] = null;
      else if (!isNaN(obj[key])) obj[key] = +obj[key];

    return obj;
  } catch (error) {
    return {};
  }
}

export function userDropdownLabel(user) {
  return `${capitalizeName((user?.firstName || "") + " " + (user?.lastName || ""))} / ${
    user?.email || user?.employee?.email || ""
  } / ${user?.employee?.employeeId || ""}`;
}

export function contractorDropdownLabel(employee) {
  return `${capitalizeName(employee?.firstName + " " + employee?.lastName)} / ${
    employee?.aadharNumber
  } / ${employee?.srNo}`;
}

export function employeeDropdownLabel(employee) {
  return `${capitalizeName(employee?.firstName + " " + employee?.lastName)} / ${
    employee?.email
  } / ${employee?.employeeId}`;
}

export function fullNameLabel(employee) {
  return `${capitalizeName(employee?.firstName + " " + employee?.lastName)}`;
}

export function employeeDesignationLabel(employee) {
  return `${employee?.designation} / ${employee?.employeeId}`;
}

export function contractorDesignationLabel(employee) {
  return `${employee?.designation} / ${employee?.srNo}`;
}

export const paginationOptionsObj = {
  // custom: true,
  paginationSize: 5,
  pageStartIndex: 1,
  firstPageText: "First",
  prePageText: "Back",
  nextPageText: "Next",
  lastPageText: "Last",
  nextPageTitle: "First page",
  prePageTitle: "Pre page",
  firstPageTitle: "Next page",
  lastPageTitle: "Last page",
  showTotal: true,
};

export const mobilePaginationOptionsObj = {
  sizePerPage: 50,
  ...paginationOptionsObj,
};

export const customColumnMatch = ({ searchText, value, column, row }) => {
  // console.log("searchText", searchText);
  // console.log("value", value);
  // console.log("column", column);
  // console.log("row", row);
  if (!searchText) return true;
  let flagCheck = 0;
  if (typeof value === "string")
    value?.toLowerCase().includes(searchText.toLowerCase()) && flagCheck++;
  else if (
    typeof value === "object" &&
    column.text !== "Action" &&
    column.text !== "Form A Data"
  ) {
    row[column?.dataField] &&
      row[column?.dataField]
        ?.toString()
        ?.toLowerCase()
        .includes(searchText?.toString()?.toLowerCase()) &&
      flagCheck++;
  }
  return flagCheck ? true : false;
};

export const parseJson = (data) => {
  try {
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
};

export const isLogin = () => {
  if (localStorage.getItem("jwt_token")) {
    return true;
  }

  return false;
};

export const customSearchFilter = (searchText, searchColumn, obj) => {
  let flag = 0;
  for (const key in obj)
    if (searchColumn.includes(key)) {
      if (
        obj[key] &&
        obj[key]
          ?.toString()
          ?.toLowerCase()
          ?.includes(searchText?.toString()?.toLowerCase())
      )
        flag++;
    }
  return flag ? true : false;
};

export const searchPlaceHolderText = (searchColumn, searchLabel) => {
  const showText = [];
  for (const key in searchLabel)
    if (searchColumn.includes(key)) showText.push(searchLabel[key]);
  return "Search by " + showText?.join(", ");
};

export const addMinutes = (time, minuteCount) => {
  return moment(time, "HH:mm").add(minuteCount, "minutes").format("HH:mm");
};

export const currentHoursMiuntes = (selectedDay) => {
  const currentDate = new Date();
  const currentHours = moment(currentDate).format("H");
  const currentMinutes = moment(currentDate).format("mm");
  const selectedHours = moment(selectedDay).format("H");
  return {
    hours: { min: 0, max: +currentHours },
    minutes: { min: 0, max: +selectedHours === +currentHours ? +currentMinutes : 59 },
  };
};

export const isAfterHoursMinutes = (selectedDay) => {
  const currentDate = new Date();
  const endTime = moment(moment(currentDate).format("h:mma"), "h:mma");
  const beginningTime = moment(moment(selectedDay).format("h:mma"), "h:mma");
  // return beginningTime?.isAfter(endTime);
  return moment(selectedDay).isSameOrBefore(moment(), "minute");
};

export const capitalizeName = (name = "") => {
  const arr = name.split(" ");

  if (arr.length > 0) {
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const newName = arr.join(" ");
    return newName;
  } else return "";
};

export const getExpiryDate = (date, years) => {
  let afterDate = moment(date).add(years, "years").format("YYYY-MM-DD");
  return moment(afterDate).subtract(1, "days").format("YYYY-MM-DD");
};

export const calaculateDatesDifference = (startDate, endDate) => {
  startDate = moment(startDate, "YYYY-MM-DD");
  endDate = moment(endDate, "YYYY-MM-DD");
  return endDate.diff(startDate, "years");
};

export const GetPMEDueDate = ({ pmeDate, startDateAtMine, age }) => {
  let years = age >= 45 ? "3" : "5";
  const NextpmeDate = moment(pmeDate).add(years, "years").format("YYYY-MM-DD");
  if (moment(NextpmeDate).isAfter(startDateAtMine)) {
    return NextpmeDate;
  } else {
    return startDateAtMine;
  }
};

export const getDateByMonthPeriod = (monthPeriod) => {
  let currentDate = moment().format("YYYY-MM-DD");
  return moment(currentDate).subtract(monthPeriod, "month").format("YYYY-MM-DD");
};

export const SORT_BY_ALPHABETICALLY = (a, b, key) => {
  if (!key || typeof key !== "string") {
    console.error("Invalid key provided");
    return 0;
  }

  const nameA = a[key] && typeof a[key] === "string" ? a[key].toUpperCase() : "";
  const nameB = b[key] && typeof b[key] === "string" ? b[key].toUpperCase() : "";

  return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
};
